import React from 'react';

export function SoraFloMark({ className = '', size = 32 }: { className?: string; size?: number }) {
  return (
    <svg
      width={size}
      height={size * 0.55}
      viewBox="3 13 42 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M5 27 C 13 27 14 16 23 16 C 32 16 33 27 43 27"
        stroke="currentColor"
        strokeWidth="3.4"
        strokeLinecap="round"
      />
      <path
        d="M5 35 C 13 35 14 24 23 24 C 32 24 33 35 43 35"
        stroke="currentColor"
        strokeWidth="3.4"
        strokeLinecap="round"
        opacity="0.32"
      />
    </svg>
  );
}
